import Splide from '@splidejs/splide';

export default function() {

	const carousels = document.getElementsByClassName('splide');
	const options = {
		type: 'loop',
		gap: '20px',
		mediaQuery: 'min',
		perPage: 1,
		focus: 0,
		autoHeight: true,
		breakpoints: {
			850: {
				perPage: 2
			}
		}
	};

	for (const carousel of carousels) {
		// In case we need to do anything with the instance later on
		const splide = new Splide(carousel, options);

		splide.on( 'overflow', function ( isOverflow ) {
			// Reset the carousel position
			splide.go( 0 );

			splide.options = {
				arrows    : isOverflow,
				pagination: isOverflow,
				drag      : isOverflow,
				clones    : isOverflow ? undefined : 0, // Toggle clones
			};
		} );

		splide.mount();
	}
}
